jQuery(document).ready(function($){

	var step1 = $('.step-1');
	var step2 = $('.step-2');
	step2.hide();

	var validationOptions = {
		highlight: function(element, errorClass) {
			var element = $(element);
            project3ErrorEvent(element.attr('name'));
			element.parents('.col-sm-8').addClass('error').find('.error-msg').text('This field is required.');
		},
		unhighlight: function(element, errorClass) {
			var element = $(element);
			element.parents('.col-sm-8').removeClass('error');
		},
		errorPlacement: function(){
			return
		}
	};

    var project3ErrorEvent = function(fieldName) {
        var event = new CustomEvent("project3.FormValidationError", {
            detail: {
                field: fieldName,
                formId: 'Signup form'
            }
        });
        document.dispatchEvent(event);
    }

	step1.validate(validationOptions);
	step2.validate(validationOptions);

	$('.submit-signup-form').on('click', function(){

		if(step2.hasClass('active') && step2.valid()) {
			submitSignupForm();
		}

		if(step1.hasClass('active') && step1.valid()) {
            var event = new CustomEvent("project3.SignupStep2Viewed");
            document.dispatchEvent(event);
			step1.removeClass('active').hide();
			step2.addClass('active').show();
		}

		return false;
	});






    function show_error_tooltips(fields) {
        var step1HasErrors = false;

        for(var fieldKey in fields){

            var field = fields[fieldKey];

            if (field.el) {

                var parentBox = $(field.el).parents('.col-sm-8');

                parentBox.find('.error-msg').html(field.error);

                parentBox.addClass('error');

                project3ErrorEvent(field.el);
            }

            if(field.el == 'input[name="full-name"]' || field.el == 'input[name="email"]' || field.el == 'input[name="password"]'){
                step1HasErrors = true;
            }
        }

        if (step1HasErrors) {
            // if any errors in step 1, show those first
            step2.hide().removeClass('active');
            step1.show().addClass('active');
        }
    }

    function remove_all_error_tooltips() {
        step1.find('.col-sm-8').removeClass('error');
        step2.find('.col-sm-8').removeClass('error');
    }





	function submitSignupForm() {
		var request_data = {
			name: step1.find('input[name="full-name"]').val(),
			email: step1.find('input[name="email"]').val(),
			password1: step1.find('input[name="password"]').val(),
			company: step2.find('input[name="organization"]').val(),
			phone: step2.find('input[name="phone"]').val(),
			number_of_employees: step2.find('select[name="employees"]').val(),
			Email_Opt_In__c: false,
			distinct_id: mixpanel.get_distinct_id(),
			extras: JSON.stringify({
                    'Last_Touch_Medium__c': Cookies.get('mixpanel_utm_medium'),
                    'Last_Touch_Source__c': Cookies.get('mixpanel_utm_source'),
                    'Last_Touch_Campaign__c': Cookies.get('mixpanel_utm_campaign'),
                    'Last_Touch_Content__c': Cookies.get('mixpanel_utm_content'),
                    'Last_Touch_Keyword__c': Cookies.get('mixpanel_utm_term'),
                    'Last_Touch_Test_ID__c': Cookies.get('mp_Last_Touch_Test_ID__c'),
                    'Last_Touch_Test_Variant__c': Cookies.get('mp_Last_Touch_Test_Variant__c'),
                    'Last_Touch_Ad_Variant__c': Cookies.get('mp_Last_Touch_Ad_Variant__c'),
                    'Last_Touch_Webpage__c': Cookies.get('mp_Last_Touch_Webpage__c'),
                    'Email_Opt_In__c': false,
                    'Job_Role__c': step2.find('select[name="role"]').val()
                })
		};
		$.post('/register_ajax/', request_data, function (response, status, xhr) {

		    var respCheck = true;

            try {
                response = JSON.parse(response);
            } catch(e) {
                //It's not JSON, so we received a 302 redirect because the user is logged in already

                respCheck = false;
                console.log('Redirect from register_ajax');

                remove_all_error_tooltips();
                show_error_tooltips([{
                    el: 'input[name="email"]',
                    error: 'It looks like you\'re logged into Mixpanel already.<br>Please log out and try again.'
                }]);
            }

            if(respCheck) {

                if (response.status_text === 'error') {

                    var tooltip_errors = [];

                    var errors = JSON.parse(response.errors);

                    var errorMapping = {
                        name: 'full-name',
                        email: 'email',
                        password1: 'password',
                        company: 'organization',
                        phone: 'phone',
                        number_of_employees: 'employees',
                        already_invited_error: 'email'
                    };

                    for (var errorKey in errors) {
                        var error = errors[errorKey];
                        var newErroKey = (errorMapping[errorKey]) ? errorMapping[errorKey] : errorKey;
                        newErroKey = (newErroKey == 'employees') ? 'select[name="' + newErroKey + '"]' : 'input[name="' + newErroKey + '"]';
                        tooltip_errors.push({
                            el: newErroKey,
                            error: error[0].message
                        });
                    }

                    remove_all_error_tooltips();
                    show_error_tooltips(tooltip_errors);

                } else {
                    var employee_value = step2.find('select[name="employees"]').val();
                    var employee_choices = [
                        '1',
                        '2-10',
                        '11-50',
                        '51-200',
                        '201-500',
                        '501-1,000',
                        '1,001-5,000',
                        '5,001-10,000',
                        '10,001+'
                    ];
                    var employees = employee_value ? employee_choices[employee_value - 1] + ' employees' : 'N/A';

                    var event = new CustomEvent("project3.SignUp", {
                        detail: {
                            is_invited_user: false,
                            email: request_data.email
                        }
                    });
                    document.dispatchEvent(event);

                    var event = new CustomEvent("signupCreated", {
                        "detail": {
                            "employees": employees,
                            "source": this.source,
                            "employeeIndex": employee_value,
                            "jobRole": step2.find('select[name="role"]').val()
                        }
                    });
                    document.dispatchEvent(event);
                    if (typeof ga === "function") {
                        ga('send', 'event', 'Inquiry', 'Sign up', employees);
                    }
                    if (typeof mixpanel === "function") {
                        mixpanel.track('Sign Up', {
                            'Source': this.source,
                            'Employees': employees
                        });
                    }

                    window._vis_opt_queue = window._vis_opt_queue || [];
                    window._vis_opt_queue.push(function () {
                        _vis_opt_register_conversion(3, 11);
                    });
                    window._vis_opt_queue.push(function () {
                        _vis_opt_register_conversion(1, 10);
                    });
                    window._vis_opt_queue.push(function () {
                        _vis_opt_goal_conversion(202);
                    });

                    if(response.redirect_url) {

                        var redirect_url = 'https://mixpanel.com' + response.redirect_url;
                        window.location.href = redirect_url;
                    }
                }
            }
        });
	}

});